// Which meter an asset tracks, derived from its vehicle_type.
// Machines (default) → hour meter; road vehicles → odometer km; trailers/attachments → none.
const KM_TYPES = ["ute", "truck", "van", "car", "pickup", "vehicle"];
const NONE_TYPES = ["trailer", "attachment"];

export const meterTypeFor = (vehicleType) => {
  const t = (vehicleType || "").trim().toLowerCase();
  if (!t) return "km";
  if (NONE_TYPES.some((k) => t.includes(k))) return "none";
  if (KM_TYPES.some((k) => t.includes(k))) return "km";
  return "hours";
};

export const meterInfo = (v) => {
  const type = meterTypeFor(v?.vehicle_type);
  if (type === "hours") {
    const n = Number(v?.machine_hours || 0);
    return {
      type, label: "Machine hours", shortLabel: "Hours",
      value: n ? `${n.toLocaleString("en-NZ")} hrs` : "—",
      shortValue: n ? n.toLocaleString("en-NZ") : "—",
    };
  }
  if (type === "km") {
    const n = Number(v?.odometer || 0);
    return {
      type, label: "Odometer", shortLabel: "Odo (km)",
      value: n ? `${n.toLocaleString("en-NZ")} km` : "—",
      shortValue: n ? n.toLocaleString("en-NZ") : "—",
    };
  }
  return { type, label: "Meter", shortLabel: "Meter", value: "—", shortValue: "—" };
};
